import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import { Alert, Button, Loader } from '..';
import {
  DeclineOfferLetter,
  SignWithDocusign,
  DocusignSent,
  SignWithOtp,
  OfferLetterDeclined,
  OfferLetterOptions,
  OfferLetterSigned,
  OfferLetterSignFailed,
} from './SubComponents';
import './_OfferLeter.scss';

const OfferLetter = ({ application, refetch }) => {
  const [visiblePopup, setVisiblePopup] = useState('OfferLetterOptions');
  const [loading, setLoading] = useState(false);

  const pendingOffer =
    application &&
    application.status &&
    application.status.name !== 'APPROVED' &&
    application.status.name !== 'DENIED' &&
    application.reviewFeedbacks &&
    application.reviewFeedbacks.find(
      feedback => feedback.status === 'PENDING',
    ) &&
    application.reviewFeedbacks.find(
      feedback =>
        feedback.status === 'PENDING' &&
        feedback.reviewType === 'OFFER_LETTER_REQUEST',
    );

  const offerLetterDocument = pendingOffer
    ? pendingOffer.documentRequests[0].document
    : {};

  return (
    <Fragment>
      {pendingOffer ? (
        <section className="offer-letter">
          {loading ? <Loader /> : ''}

          {visiblePopup && visiblePopup === 'OfferLetterOptions' ? (
            <OfferLetterOptions
              application={application}
              pendingOffer={pendingOffer}
              popupToggle={setVisiblePopup}
              document={offerLetterDocument}
              setLoading={setLoading}
              refetch={refetch}
            />
          ) : (
            ''
          )}

          {visiblePopup && visiblePopup === 'SignWithDocusign' ? (
            <SignWithDocusign
              application={application}
              pendingOffer={pendingOffer}
              popupToggle={setVisiblePopup}
              setLoading={setLoading}
            />
          ) : (
            ''
          )}

          {visiblePopup && visiblePopup === 'SignWithOtp' ? (
            <SignWithOtp
              application={application}
              pendingOffer={pendingOffer}
              popupToggle={setVisiblePopup}
              setLoading={setLoading}
              refetch={refetch}
            />
          ) : (
            ''
          )}

          {visiblePopup && visiblePopup === 'DeclineOfferLetter' ? (
            <DeclineOfferLetter
              application={application}
              pendingOffer={pendingOffer}
              popupToggle={setVisiblePopup}
              setLoading={setLoading}
              refetch={refetch}
            />
          ) : (
            ''
          )}

          {visiblePopup && visiblePopup === 'DocusignSent' ? (
            <DocusignSent
              application={application}
              pendingOffer={pendingOffer}
              popupToggle={setVisiblePopup}
              refetch={refetch}
            />
          ) : (
            ''
          )}

          {visiblePopup && visiblePopup === 'OfferLetterSigned' ? (
            <OfferLetterSigned
              application={application}
              pendingOffer={pendingOffer}
              popupToggle={setVisiblePopup}
              refetch={refetch}
            />
          ) : (
            ''
          )}

          {visiblePopup && visiblePopup === 'OfferLetterSignFailed' ? (
            <OfferLetterSignFailed
              application={application}
              pendingOffer={pendingOffer}
              popupToggle={setVisiblePopup}
            />
          ) : (
            ''
          )}

          {visiblePopup && visiblePopup === 'OfferLetterDeclined' ? (
            <OfferLetterDeclined
              application={application}
              pendingOffer={pendingOffer}
              popupToggle={setVisiblePopup}
              refetch={refetch}
            />
          ) : (
            ''
          )}

          {!visiblePopup ? (
            <Alert classes="error">
              Your need to sign the offer letter attached to your application in
              order to process your loan. Click{' '}
              <Button
                click_event={() => setVisiblePopup('OfferLetterOptions')}
                classes="button-link"
              >
                here
              </Button>{' '}
              to sign the offer letter
            </Alert>
          ) : (
            ''
          )}
        </section>
      ) : (
        ''
      )}
    </Fragment>
  );
};

OfferLetter.propTypes = {
  application: PropTypes.object,
};

export default OfferLetter;
